import React from "react";
import { CreditCardIcon, MailIcon, DownloadIcon } from "lucide-react";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
const steps = [{
  icon: CreditCardIcon,
  title: "Completas tu compra",
  text: "Pago único de {precio} en la plataforma de pago segura."
}, {
  icon: MailIcon,
  title: "Recibes el acceso",
  text: "Te llega un correo electrónico con el enlace a tus materiales."
}, {
  icon: DownloadIcon,
  title: "Descargas y empiezas",
  text: "Abres el Volumen 1 y el Día 1 del plan, desde donde estés."
}];
export function DigitalAccessSection() {
  const {
    mainPrice
  } = useLocalizedPrices();
  return <section className="border-t border-cocoa-900/10 bg-cream-100 py-14 sm:py-24" data-id="element-79" data-mp="3gq9x9ye8mj4e">
      <div className="mx-auto max-w-6xl px-5" data-id="element-80" data-mp="3kpiqn25d8ezf">
        <h2 className="max-w-2xl font-display text-3xl font-semibold leading-tight text-cocoa-900 sm:text-4xl" data-id="element-81" data-mp="3ko7of6rkjfaf">
          Acceso 100% digital. <em className="font-medium text-caramel-600" data-id="element-82" data-mp="1qbzn9bonm267">Sin envíos, sin esperas de correo postal.</em>
        </h2>
        <ol className="mt-12 grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-83" data-mp="2flxuolgsiqdp">
          {steps.map((s, i) => {
          const Icon = s.icon;
          return <li key={s.title} className="relative md:pr-6" data-id="element-84" data-mp="25v2v6fej9uab" data-mpi={i}>
                <div className="flex items-center gap-4" data-id="element-85" data-mp="25vkytx3izas9">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-cocoa-900 text-caramel-300" data-id="element-86" data-mp="20wi4p7p32oz2">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-87" data-mp="2yip6k9u0637q" />
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-wider text-cocoa-600" data-id="element-88" data-mp="2tlp408wd3ild">Paso {i + 1}</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-cocoa-900" data-id="element-89" data-mp="2onnlbp2ullaf">{s.title}</h3>
                <p className="mt-2 leading-relaxed text-cocoa-700" data-id="element-90" data-mp="2jlybgcrd3dnx">{s.text.replace("{precio}", mainPrice)}</p>
              </li>;
        })}
        </ol>
        <p className="mt-12 text-sm text-cocoa-600" data-id="element-91" data-mp="1871feiwrfo72">Formato PDF para leer en celular, tablet o computadora. Planilla compatible con Excel y Google Sheets.</p>
      </div>
    </section>;
}